module.exports = __webpack_public_path__ + "static/media/logo-13.0cbb4ad9.jpg";